/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
  adminHasPermission,
  cleanUpAdminCustomers,
} from '../../utils/helpers';
import useCustomQuery from '../../network/useCustomQuery';
import useGetQueryParams from '../../customHooks/useGetQueryParams';
import { GET_ALL_CUSTOMERS } from '../../graphql/admin_queries';
import AdminTable from '../../components/AdminTable';
import DashboardHeader from '../../components/DashboardHeader';
import useToast from '../../customHooks/useToast';
import useFilterMethods from '../../customHooks/useFilterMethods';
import EmptyRecord from '../../components/EmptyRecord';
import useTableColumn from '../../customHooks/useTableColumn';
import generatePDF from '../../utils/generatePdf';
import generateCSV from '../../utils/generateCSV';
import EmptyAdminCuatomerIcon from '../../svgs/EmptyAdminCuatomerIcon';
// import { useGlobalState } from '../../contexts/AdminGlobalContext';
import RolesAndPermissionGuard from '../../components/RolesAndPermissionGuard';
import PermissionDenied from '../PermissionDenied';
import { useGlobalState } from '../../contexts';
import { AdminRouteName } from '../CONSTANTS';
import AdminLinkTabs from '../../components/AdminLinkTabs';
import CustomerTabs from './CustomerTabs';
// import { loadpayfiProduct } from '../../contexts/AdminGlobalContext';

const limit = 14;
interface IMerchantTableRecord{
defaultUrl?:string;
toggleStorageId?:string;
tabStatus?:string;
hasNameAndImage?:boolean;
permissionName: string;
}
const CustomerTableRecords = ({
  defaultUrl, toggleStorageId, tabStatus, hasNameAndImage, permissionName,
}:IMerchantTableRecord) => {
  const { profile }:any = useGlobalState();
  const adminPermissions = profile?.role?.permissions || [];
  const Toast = useToast();
  const [getCustomers, getCustomerLoading, customers] = useCustomQuery({
    query: GET_ALL_CUSTOMERS,
    onError: () => {},
    onData: () => {},
  });

  const { getQuery, getFilterQueries } = useGetQueryParams();
  const search = getQuery('search') || '';
  const page = Number(getQuery('page'));
  const { push } = useHistory();

  const allColumns = [
    ['image', 'email', 'hasBottomValue', 'name'],
    'phone',
    ...(tabStatus === 'DELETED' ? ['dateDeleted'] : ['date']),
    'productPreference',
    'status',
    'lastLoginAt',
  ];
  const columnLabelFormat = {
    name: 'Customer',
    phone: 'Phone Number',
    date: 'Date Registered',
    productPreference: 'Preference',
    status: 'Status',
    lastLoginAt: 'Last Login',
    // image__name: 'Name',
    dateDeleted: 'Date Deleted',
  };
  const { getColumns, applyChanges, selectedColumns } = useTableColumn(allColumns, toggleStorageId);

  const [customerRec, setcustomerRec] = useState(null);
  const setPage = (pageNum) => {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set('page', pageNum);
    push({
      search: searchParams.toString(),
    });
  };
  if (!page) {
    push(`${defaultUrl}?page=1&search=${search}`);
  }

  const onSearchChange = (e) => {
    push(`${defaultUrl}?page=1&search=${encodeURIComponent(e.target.value)}`);
  };

  const TabsRaw = [
    {
      id: 1,
      name: 'All',
      link: AdminRouteName.customersRoute,
      permission: 'can-view-all-customers',
      count: customerRec?.count || 0,
    },
    {
      id: 2,
      name: 'Active',
      link: AdminRouteName.activeCustomersRoute,
      permission: 'can-view-all-customers',
      count: customerRec?.count || 0,
    },
    {
      id: 3,
      name: 'Inactive',
      link: AdminRouteName.inactiveCustomersRoute,
      permission: 'can-view-all-customers',
      count: customerRec?.count || 0,
    },
    {
      id: 4,
      name: 'Awaiting Approval',
      link: AdminRouteName.awaitingApprovedCustomersRoute,
      permission: 'can-view-all-customers',
      count: customerRec?.count || 0,
    },
    {
      id: 4,
      name: 'Prospective',
      link: AdminRouteName.prospectiveCustomersRoute,
      permission: 'can-view-all-customers',
      count: customerRec?.count || 0,
    },

  ];

  const Tabs = TabsRaw?.map((tab) => ({
    ...tab,
    disabled: !adminHasPermission(adminPermissions, tab.permission),
  }));

  const getCustomersFunc = async (result, offset, lim = limit) => getCustomers({
    variables: {
      offset,
      limit: lim,
      ...(tabStatus ? { statusFilter: tabStatus } : {}),
      search,
      filters: {
        from: result?.from,
        to: result?.to,
        preference: result?.preference,
        ...(tabStatus ? {} : { status: result?.status }),
        minAmount: result?.min ? Number(result?.min) : 0,
        maxAmount: result?.max ? Number(result?.max) : 0,
      },
    },
  });

  useEffect(() => {
    if (page) {
      const result = getFilterQueries();
      getCustomersFunc(result, (page - 1) * limit);
    }
  }, [page, search]);

  const onFilterSubmit = (result) => {
    getCustomersFunc(result, 0);
  };

  const {
    filterObj,
  } = useFilterMethods({
    allowedFilters: tabStatus ? ['dateRange', 'preference'] : ['dateRange', 'status', 'preference'],
    defaultUrl,
    cb: onFilterSubmit,
    Toast,
    customFilterInformation: {
      dateRange: {
        label: 'Date Registered',
      },
      preference: {
        label: 'Product Preference',
      },
      status: {
        label: 'Status',
        options: [
          {
            label: 'Active',
            value: 'ACTIVE',
          },
          {
            label: 'Inactive',
            value: 'DECLINED',
          },
          {
            label: 'Prospective',
            value: 'PROSPECTIVE',
          },
          {
            label: 'Awaiting Approval',
            value: 'AWAITING_APPROVAL',
          },

        ],
      },
    },
  });

  useEffect(() => {
    if (customers?.usersCa?.users) {
      setcustomerRec(customers?.usersCa);
    }
  }, [customers]);

  const [getExportRecord] = useCustomQuery({
    query: GET_ALL_CUSTOMERS,
    onError: () => {},
    onData: () => {},
  });

  const handleExport = async (type: string) => {
    try {
      const result = getFilterQueries();
      const output = await getExportRecord({
        variables: {
          offset: 0,
          limit: 2000,
          ...(tabStatus ? { statusFilter: tabStatus } : {}),
          search,
          filters: {
            from: result?.from,
            to: result?.to,
            preference: result?.preference,
            status: result?.status,
            minAmount: result?.min ? Number(result?.min) : 0,
            maxAmount: result?.max ? Number(result?.max) : 0,
          },
        },
      });
      if (output?.data?.usersCa?.users) {
        const rec = cleanUpAdminCustomers(output?.data?.usersCa?.users);
        const func = type === 'pdf' ? generatePDF : generateCSV;
        const selectedHeaders = [
          'S/N',
          // change image__email__hasBottomValue__name concated columns to a single column of name
          ...(getColumns?.()?.map((column) => (column === 'image__email__hasBottomValue__name' ? ['name', 'email'] : column)) || []),
        ];

        func({
          payload: rec,
          title: 'CUSTOMER',
          selectedHeaders,
          formatHeaders: columnLabelFormat,
          cb: () => Toast.success('Exported successfully'),
        });
      }
    } catch (error) {
      Toast.error('Error while exporting');
    }
  };

  return (
    <div>
      <DashboardHeader
        title="Customers"
        smallSubTitle={`(${customerRec?.count || 0})`}
        searchPlaceholder="Search by User ID, customer’s name, email address and phone number"
        search={search}
        onSearchChange={onSearchChange}
        searchLoading={getCustomerLoading}
        filterObj={filterObj}
        columnObject={{
          allColumns,
          formatLabels: columnLabelFormat,
          applyChanges,
          selectedColumns,
        }}
        disableSearch={!adminHasPermission(adminPermissions, 'can-search-customers-record')}
        disableExport={!adminHasPermission(adminPermissions, 'can-export-selected-data')}
        disbleFilter={!adminHasPermission(adminPermissions, 'can-filter-customer-record')}
        exportObj={{
          handleExport,
        }}

      >
        <AdminLinkTabs>
          <CustomerTabs Tabs={Tabs} />
        </AdminLinkTabs>
      </DashboardHeader>
      <RolesAndPermissionGuard permissionName={permissionName} hasErrorTemplate={<PermissionDenied height="60vh" />}>
        <div className="merchant-table-details-cover">
          {customerRec?.count ? (
            <AdminTable
              refreshing={getCustomerLoading}
              page={page}
              setPage={setPage}
              pageSize={limit}
              minHeight="calc(100vh - 280px)"
              count={customerRec?.count}
              contents={cleanUpAdminCustomers(customerRec?.users)}
              reference="id"
              hideDominantImage
              clickable
              hasNameAndImage={hasNameAndImage}
              handleClick={(data) => {
                push(`/customers/customer-details/${data.id}/profile`);
              }}
              allowKeyArr={getColumns(true)}
              mobileAllowKeyArr={
                [
                  'status',
                  ['name', 'payfiId'],
                  ['phone', 'email'],
                ]
              }
              formatLabels={columnLabelFormat}
            />
          ) : (
            <EmptyRecord
              height="calc(100vh - 240px)"
              title={getCustomerLoading ? 'Fetching merchants...' : 'No customers found'}
              main="All customers and their transaction details will appear here on the dashboard."
              // footer="Receive Payments"
              loading={getCustomerLoading}
              Icon={EmptyAdminCuatomerIcon}
            />
          )}

        </div>
      </RolesAndPermissionGuard>
    </div>
  );
};
export default CustomerTableRecords;
